import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { courierKeys, listCouriers } from '@dukanti/shared';
import type { Courier } from '@dukanti/shared';
import { supabase } from '@/lib/supabase';

export function useCouriers(storeId: string | null, enabled = true): UseQueryResult<Courier[]> {
  return useQuery<Courier[]>({
    queryKey: courierKeys.list(storeId),
    enabled: enabled && !!storeId,
    queryFn: () => listCouriers(supabase, storeId as string),
  });
}
